
const endpoints = {
        "ingByName": "https://www.thecocktaildb.com/api/json/v1/1/search.php?i=",
        "cocByID": "https://www.thecocktaildb.com/api/json/v1/1/lookup.php?i=",
        "cocRandom": "https://www.thecocktaildb.com/api/json/v1/1/random.php",
        "cocTenRandom": "https://www.thecocktaildb.com/api/json/v1/1/randomselection.php",
        "byName": "https://www.thecocktaildb.com/api/json/v1/1/search.php?s="
}

export {endpoints};
